export const getFrequencyName = (inputVal) => {
  const frequencyMap = {
    DAILY: "D",
    WEEKLY: "W",
    FORTNIGHTLY: "F",
    MONTHLY: "M",
    QUARTERLY: "Q",
    HALFYEARLY: "H",
    YEARLY: "Y",
  };
  const reverseFrequencyMap = {};
  for (const key in frequencyMap) {
    reverseFrequencyMap[frequencyMap[key]] = key;
  }

  if (Object.values(frequencyMap).includes(inputVal.toUpperCase())) {
    return reverseFrequencyMap[inputVal.toUpperCase()];
  }

  return frequencyMap[inputVal.toUpperCase()] || inputVal.toUpperCase();
};

export function SwitchDetails(props) {
  return (
    <div
      style={{
        color: "#293139",
        fontSize: 14,
        fontWeight: "bold",
      }}
    >
      {props.name}
    </div>
  );
}
